module.exports = __webpack_public_path__ + "static/media/download-white.f3966f57.svg";